import { Tooltip, TooltipTrigger } from '@vizit/atoms';
import { isOtherRetailerRegion } from '@vizit/constants';
import { useShowUniversalBenchmarks } from '@vizit/feature-flags';
import React from 'react';
import { Button } from 'react-aria-components';
import { getRetailerIcon } from '../retailer-icons';

export interface ProductListingRowRetailerProps {
  /** The page's retailer region (e.g. 'amazon_us') */
  retailer?: string;
  /** Label of the benchmark the page is scored against, shown for the Other retailer */
  benchmarkLabel?: string | null;
  /** Opens the page, as the rest of the row does; the icon's button would otherwise swallow the click */
  onPress?: () => void;
}

const ProductListingRowRetailer = React.memo<ProductListingRowRetailerProps>(
  ({ retailer, benchmarkLabel, onPress }) => {
    const showUniversalBenchmarks = useShowUniversalBenchmarks();
    const RetailerIcon = getRetailerIcon(retailer, { showOther: showUniversalBenchmarks });

    if (showUniversalBenchmarks && isOtherRetailerRegion(retailer)) {
      return (
        <TooltipTrigger delay={500}>
          <Button aria-label="Other retailer" className="flex items-center outline-none" onPress={onPress}>
            {RetailerIcon && <RetailerIcon size={20} />}
          </Button>
          <Tooltip>
            <span className="block">Other retailer</span>
            {benchmarkLabel && <span className="block">{benchmarkLabel}</span>}
          </Tooltip>
        </TooltipTrigger>
      );
    }

    return RetailerIcon ? <RetailerIcon size={20} /> : null;
  },
);

ProductListingRowRetailer.displayName = 'ProductListingRowRetailer';

export { ProductListingRowRetailer };
